import { SubscriptionFrequency } from "../SubscriptionFrequency.js";

export const subscriptionFrequencyToWeeksMap: Record<SubscriptionFrequency, number> = {
	[SubscriptionFrequency.Weeks2]: 2,
	[SubscriptionFrequency.Weeks3]: 3,
	[SubscriptionFrequency.Weeks4]: 4,
	[SubscriptionFrequency.Weeks5]: 5,
	[SubscriptionFrequency.Weeks6]: 6,
};
